$(function(){
  var diagnosis = $('#diagnosis').slick({
    adaptiveHeight: true,
    autoplay: false,
    dots: false,
    arrows: false,
    draggable: false,
    infinite: false,
    swipe: false,
    touchMove: false,
    fade: true,
  });
  const score = {
    'humanist': 0,
    'connector': 0,
    'professor': 0,
    'challenger': 0,
  }
  const result = {
    'humanist': 13,
    'connector': 14,
    'professor': 15,
    'challenger': 16,
  }
  $('input').on('click', function(){
    if($(this).attr('name') === 'start') {
      diagnosis.slick('slickNext');
    } else {
      const name = $(this).attr('name').split('_');
      // console.log(parseInt($(this).val()), name[0]);
      score[name[0]] += parseInt($(this).val());
      // console.log(score);
      if (name[1] !== 'q12') {
        diagnosis.slick('slickNext');
      } else {
        const maxValue = Math.max(...Object.values(score));

        // 2. 最大値と同じ値を持つキーをすべて抽出
        const maxKeys = Object.keys(score).filter(key => score[key] === maxValue);

        // 3. 配列の中からランダムに1つ選ぶ
        const selectedKey = maxKeys[Math.floor(Math.random() * maxKeys[maxKeys.length])]; // 修正：インデックス指定
        const randomIndex = Math.floor(Math.random() * maxKeys.length);
        const finalKey = maxKeys[randomIndex];
        // console.log(maxKeys);
        // console.log(finalKey);
        let url = new URL(window.location.href);
        url.searchParams.set('result', finalKey);
        console.log(url);
        window.history.pushState({}, '', url);
        diagnosis.slick('slickGoTo',result[finalKey]);
      }
    }
  });

  $('[data-retry]').on('click', function(){
    $('input').prop('checked', false);
    let url = new URL(window.location.href);
    url.searchParams.delete('result');
    window.history.pushState({}, '', url);
    diagnosis.slick('slickGoTo',0);
    score['humanist'] = 0;
    score['connector'] = 0;
    score['professor'] = 0;
    score['challenger'] = 0;
    return false;
  });

  const sampleParams = new URLSearchParams(window.location.search);
  if (sampleParams.get('result')) {
    const type = sampleParams.get('result')
    diagnosis.slick('slickGoTo',result[type]);
  }

});